import { Column, ModelBase } from 'loca-boot-core'
/**
 * 加电资源概览
 */
export class SummaryModel extends ModelBase {
  /**
   * 统计范围，city--城市级别，country--国家级别
   */
  @Column()
  public statisticRange!: string

  /**
   * 换电站数量
   */
  @Column()
  public swapNumber!: string

  /**
   * 超充桩群数量
   */
  @Column()
  public nioNpcChargerNumber!: string

  /**
   * 超充枪数量
   */
  @Column()
  public nioNpcConnectorNumber!: string

  /**
   * 目充桩群数量
   */
  @Column()
  public nioDestChargerNumber!: string

  /**
   * 目充枪数量
   */
  @Column()
  public nioDestConnectorNumber!: string

  /**
   * 三方枪数量
   */
  @Column()
  public thirdConnectorNumber!: string

  /**
   * 更新时间
   */
  @Column()
  public statisticUpdateTime!: string

  /**
   * 高速换电站数量，仅country级别有
   */
  @Column()
  public highSpeedSwapNumber!: string

  /**
   * nio桩群总数
   */
  @Column()
  public nioChargerNumber!: string

  /**
   * nio枪总数
   */
  @Column()
  public nioConnectorNumber!: string

  /**
   * 累计换电次数
   */
  @Column()
  public psDistrictHousingCoveredRate!: string

  /**
   * 路径规划起点终点
   */
  @Column()
  public totalSwapTimesNumber!: string

  /**
   * 高速公路充电站 座
   */
  @Column()
  public highSpeedNioChargerNumber!: string

  /**
   * 高速公路充电站 根
   */
  @Column()
  public highSpeedNioConnectorNumber!: string
}

export class IndicatorModel extends ModelBase {
  @Column()
  public indicatorCode!: string
  @Column()
  public indicatorValue!: number
  @Column()
  public eventTimestamp!: number
  @Column()
  public eventTimeDesc!: string
}

/**
 * 累计换电次数，准实时数据
 */
export class ChargerOrderCountModel extends ModelBase {
  /**
   * 实时订单数
   */
  @Column({ name: 'real_time_order_count' })
  public realTimeOrderCount!: string
  /**
   * 实时充电订单数
   */
  @Column({ name: 'realtime_charge_order_num' })
  public realtimeChargeOrderNum!: IndicatorModel
  /**
   * 实时换电订单数
   */
  @Column({ name: 'realtime_swap_order_num' })
  public realtimeSwapOrderNum!: IndicatorModel
}
